import React, { useEffect, useReducer } from "react";
import styled from "styled-components";
import { Accordion } from "./components/setting-accordion";
import { Input } from "./components/input";
import { SaveButton } from "./components/save-button";
import SettingIcon from "../../../../../../images/settings-icons/setting-name.png";
import { modifyUser } from "../../../../../../api";

const Row = styled.div`
  display: flex;
  @media (max-width: 900px) {
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-end;
  }
`;

const initialState = {
  show: false,
  name: "",
  loading: false,
};

const settingReducer = (state, action) => {
  switch (action.type) {
    case "field": {
      return {
        ...state,
        [action.field]: action.value,
      };
    }
    case "setShow": {
      return {
        ...state,
        show: action.value,
      };
    }
    case "setLoading": {
      return {
        ...state,
        loading: action.value,
      };
    }
    default:
      break;
  }

  return state;
};

const UpdateName = (props) => {
  const [state, dispatch] = useReducer(settingReducer, initialState);
  const { show, name, isLoading } = state;

  useEffect(() => {
    dispatch({ type: "field", field: "name", value: props.fullName });
  }, [props.fullName]);

  const handleSubmit = () => {
    let mods = {};
    mods["full_name"] = name;
    dispatch({ type: "setLoading", value: true });

    modifyUser(props.userId, props.portalId, mods).then((res) => { 
      dispatch({ type: "setLoading", value: false});
      props.loadPortalAccount();
      props.openSnackbar("Client's name has been updated", false)
    }).catch((err) => {
      dispatch({ type: "setLoading", value: false });
      props.openSnackbar('Unable to name', true)
    });
  };

  const handleReset = () => {
    dispatch({ type: "field", field: "name", value: props.fullName })
  }

  const disabled = name === props.fullName || name === "";

  return (
    <>
      <Accordion
        show={show}
        setShow={(val) => dispatch({ type: "setShow", value: val })}
        handleReset={handleReset}
        icon={SettingIcon}
        settingName="Name"
        currentSetting={props.fullName}
        description="Please use your full name"
        roundTop
      >
        <Row>
          <Input
            onChange={(e) =>
              dispatch({ type: "field", field: "name", value: e.target.value })
            }
            value={name}
          />
          <SaveButton
            disabled={disabled}
            isLoading={isLoading}
            onClick={handleSubmit}
          />
        </Row>
      </Accordion>
    </>
  );
};

export default UpdateName;
